import type { ColumnType } from 'xui-pro';
import { useMemo } from 'react';
import { Tag } from 'antd';
import type { Part } from '@/api/epc/catalog/usageUsingPOST';
import EllipsisText from '@/components/EllipsisText';
import styles from './index.module.less';
const useColumns = isInIframe => {
  const columns = useMemo(() => {
    return [
      {
        title: '选择',
        width: 52,
        hidden: !isInIframe,
        render: (_, record) => {
          const { partNo, salePrice, priceDisplay, saleState } = record;
          const canAdd = !!(priceDisplay && salePrice && saleState);
          return (
            <div
              className={canAdd ? styles.addIcon : styles.unableAddIcon}
              onClick={() => {
                if (canAdd)
                  window.parent?.postMessage(
                    {
                      action: 'afs.addPartFromEPC',
                      payload: { partCode: partNo }
                    },
                    '*'
                  );
              }}
            />
          );
        }
      },
      {
        title: '序号',
        dataIndex: 'callout',
        width: 60
      },
      {
        title: '配件编码',
        dataIndex: 'partNo',
        width: 180,
        render: (partNo: string, record: any) => {
          const { partName, saleState, vinLoadingPart, photoQty, special, substitute } = record;
          return (
            <div className={styles.partItem}>
              <EllipsisText text={partNo} />
              <div className={styles.partInfo}>
                {!!vinLoadingPart && (
                  <img className={styles.loadIcon} src={require('../assets/check.png')} />
                )}
                <EllipsisText text={partName} />
              </div>
              <span className={styles.partOthers}>
                {!saleState && <Tag color='error'>停售</Tag>}
                {photoQty > 0 && (
                  <img src={require('../assets/imgIcon.png')} alt='partMoreInfo' accessKey='1' />
                )}
                {!!substitute && (
                  <img src={require('../assets/switchIcon.png')} alt='partMoreInfo' accessKey='2' />
                )}
                {!!special && (
                  <img src={require('../assets/remarkIcon.png')} alt='partMoreInfo' accessKey='3' />
                )}
              </span>
            </div>
          );
        }
      },
      {
        title: '参考数量',
        dataIndex: 'qty',
        width: 70,
        render: (qty: number) => (!!qty ? `${qty}` : '-')
      },
      {
        title: '用法备注',
        dataIndex: 'note',
        width: 90
      },
      {
        title: '操作',
        dataIndex: 'callout',
        width: 60,
        render: () => {
          return (
            <>
              <span className={styles.action}>详情</span>
              <div className={styles.detailHint}>
                <span className={styles.rect} />
                <span className={styles.triangle} />
              </div>
            </>
          );
        }
      }
    ] as ColumnType<Part>[];
  }, [isInIframe]);
  return columns;
};

export default useColumns;
